import {withStyles} from '@/hocs/withStyles';
import {Noop} from '@/hocs/noop';
import styles from './styles.module.scss';
/**
 * Used in order to bundle everything together with a single component.
 * We can use this hoc in order to align each element passed, and avoid duplications.
 * */

// Floats
const withFloatRightToCenter = (Component = Noop) => withStyles(Component, styles, 'right-to-c');

// Alignments & Responsive alignments
const withTextCenter = (Component = Noop) => withStyles(Component, styles, 'centered');
const withTextLeftToCenter = (Component = Noop) => withStyles(Component, styles, 'left-to-c');
const withTextLeftToCenterXl = (Component = Noop) => withStyles(Component, styles, 'left-to-c-xl');

export {withFloatRightToCenter, withTextCenter, withTextLeftToCenter, withTextLeftToCenterXl};
